export const enum PropertySavedIdbStatechartStateEnum {
  iddle = 'iddle',
  syncing = 'syncing',
  loadingAll = 'loadingAll',
}
